import { queryOptions } from "@tanstack/react-query";
import type { ToolResponse } from "@/app/tools/types";
import type { ScopedBinding } from "@/app/types";
import type { ApiClient } from "@/lib/api";
import { getEngineApi } from "@/lib/api";
import { HIDDEN_TOOLKITS } from "@/lib/const";
import type { OrgProjectScope } from "@/lib/resource-context";
import { toolsKeys } from "./query-keys";

const fetchTools = async ({
  client,
  userId,
}: {
  client: ApiClient;
  userId?: string;
}): Promise<ToolResponse> => {
  const { data } = await client.get<ToolResponse>("/tools", {
    params: {
      limit: 25_000,
      user_id: userId,
    },
  });

  const filteredItems = data.items.filter(
    (tool) => !HIDDEN_TOOLKITS.has((tool.toolkit?.name || "").toLowerCase())
  );

  return {
    ...data,
    items: filteredItems,
    total_count: filteredItems.length,
  };
};

export const toolsQueryOptions = ({
  binding = "project",
  userId,
  scope,
}: {
  binding?: ScopedBinding;
  userId?: string;
  scope: OrgProjectScope;
}) => {
  const client = getEngineApi(scope, binding);

  return queryOptions<ToolResponse>({
    queryKey: userId
      ? [...toolsKeys.list({ binding, scope }), "user", userId]
      : toolsKeys.list({ binding, scope }),
    queryFn: () => fetchTools({ client, userId }),
  });
};
